import React, { useState, useEffect, useRef } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  DatePicker,
  Uploader,
  Icon,
  Table,
  Message,
  SelectPicker,
  RadioGroup,
  Radio,
  Whisper,
  Tooltip,
  InputGroup,
} from 'rsuite'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import { LOCAL_DAY_TH, DD_MM_YYYY_SLASH, DATE_PICKER_FORMAT } from '../../../constants/date'
import moment from 'moment'
import { sessionGetItemJSON, sessionGetItemStr } from '../../../utils/sessionHelpers'
import PanelHeader from '../../../components/PanelHeader/PanelHeader'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import InputForm from '../../../components/forms/input/InputForm'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import { downloadBlacklistAttacthment, getRelateProject } from '../../../redux/actions/blacklist'
import { getValueFromOptions } from '../../../utils/dataUtil'
import EditSelectCell from '../../../components/cell/EditSelectCell'
import { verificationPerson } from '../../../redux/actions/verification'

export default function AddBlacklistForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  considerResultSchema,
  setConsiderResultSchema = () => {},
  setIsEnableEdit = () => {},
  blacklistedId,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const triggerRef = React.useRef()
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTableData, setFileTableData] = useState([])
  const [titleLeftStr, setTitleLeftStr] = useState('')
  const [titleRightStr, setTitleRightStr] = useState('')
  const [isVerification, setIsVerification] = useState(false)
  const [isVerificationOrg, setIsVerificationOrg] = useState(false)
  const [isLoadingVerification, setIsLoadingVerification] = useState(false)
  const [projectLists, setProjectLists] = useState([])

  const [checkRadio, setCheckRadio] = useState(formSchema?.blacklistType.value)
  const defaultMaxFileSize = 5

  useEffect(() => {
    register('deleteFileIds', [])
    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values?.length > 0) {
      setFileTableData(formSchema?.attachFiles?.values)
    }
  }, [formSchema])

  useEffect(() => {
    if (blacklistedId && formSchema?.relateProject?.values?.length > -1) {
      setProjectLists(formSchema.relateProject.values)
      setConsiderResultSchema(formSchema.relateProject)
    }

    if (formSchema.blacklistType.value == '1') {
      setIsVerification(true)
    }

    if (formSchema.blacklistType.value == '2') {
      setIsVerificationOrg(true)
    }
  }, [formSchema, blacklistedId])

  const onPreview = async (fileObj) => {
    // console.log('onPreview', fileObj)
    startLoading()
    try {
      var file = await downloadBlacklistAttacthment(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadBlacklistAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFileTable = async (rowData) => {
    // console.log('handleDeleteFileTable', rowData)

    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  const onClickVerificationPerson = async () => {
    const idNumber = getValues(formSchema.idCard.name)
    if (!idNumber) {
      return
    }
    setIsLoadingVerification(true)
    try {
      let response = await getRelateProject('', idNumber)
      if (response.model) {
        setProjectLists(response.model.values)
        setConsiderResultSchema(response.model)
        setValue(formSchema.personName.name, response.model.name)

        let _data = response.model.values?.map((item) => {
          return item.considerResult
        })

        considerResultSchema?.considerResult?.name &&
          setValue(considerResultSchema?.considerResult?.name, _data)
      }
      setIsVerification(true)
      notification.open('success', {
        title: 'ตรวจสอบสำเร็จ',
        duration: 5000,
      })
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message ||
          'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoadingVerification(false)
  }

  const onClickVerificationOrg = async () => {
    const taxNumber = getValues(formSchema.taxNumber.name)
    if (!taxNumber) {
      return
    }
    setIsLoadingVerification(true)
    try {
      let response = await getRelateProject('', taxNumber)
      if (response.model) {
        setProjectLists(response.model.values)
        setConsiderResultSchema(response.model)
        setValue(formSchema.juristicName.name, response.model.name)

        let _data = response.model.values?.map((item) => {
          return item.considerResult
        })

        considerResultSchema?.considerResult?.name &&
          setValue(considerResultSchema?.considerResult?.name, _data)
      }
      setIsVerificationOrg(true)
      notification.open('success', {
        title: 'ตรวจสอบสำเร็จ',
        duration: 5000,
      })
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message ||
          'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoadingVerification(false)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<PanelHeader leftString={titleLeftStr} rightString={titleRightStr} />}
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.blacklistType.validators, formSchema.blacklistType.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.blacklistType.name]} />
            <Controller
              name={formSchema.blacklistType.name}
              control={control}
              defaultValue={formSchema?.blacklistType.value}
              rules={isValidators(formSchema.blacklistType.validators)}
              render={(props) => {
                return (
                  <RadioGroup
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      setCheckRadio(value)
                      clearErrors()
                    }}
                  >
                    {formSchema.blacklistType.options.map((item) => (
                      <Radio key={item.value} value={item.value}>
                        <p style={{ marginTop: -3 }}>{item.label}</p>
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}></Col>
        </Row>
        {checkRadio == '1' && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
                <ControlLabel>
                  {requiredFiled(formSchema.idCard.validators, formSchema.idCard.label)}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.idCard.name]} />
                <InputGroup style={{ width: '100%' }}>
                  <Controller
                    name={formSchema.idCard.name}
                    control={control}
                    defaultValue={formSchema.idCard.value}
                    rules={isValidators(formSchema.idCard.validators)}
                    render={(props) => {
                      return (
                        <Input
                          placeholder={formSchema.idCard.label}
                          value={props.value}
                          maxLength={getMaxLengthData(formSchema.idCard.validators).value}
                          onChange={(value, e) => {
                            if (isNaN(value)) {
                              return
                            }
                            props.onChange(value)
                            setIsVerification(false)
                          }}
                        />
                      )
                    }}
                  />
                  <Whisper
                    placement="top"
                    open={!isVerification}
                    speaker={
                      <Tooltip style={{ fontSize: 15 }}>กรุณาตรวจสอบโครงการที่เกี่ยวข้อง</Tooltip>
                    }
                  >
                    <InputGroup.Button
                      onClick={() => {
                        if (isVerification || isLoadingVerification) {
                          return
                        }
                        onClickVerificationPerson()
                      }}
                      disabled={isVerification || isLoadingVerification}
                    >
                      ตรวจสอบ
                    </InputGroup.Button>
                  </Whisper>
                </InputGroup>
              </Col>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {requiredFiled(formSchema.personName.validators, formSchema.personName.label)}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.personName.name]} />
                <Input
                  name={formSchema.personName.name}
                  defaultValue={formSchema.personName.value}
                  inputRef={register(isValidators(formSchema.personName.validators))}
                  placeholder={'ระบุ' + formSchema.personName.label}
                />
              </Col>
            </Row>
          </>
        )}
        {checkRadio == '2' && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
                <ControlLabel>
                  {requiredFiled(formSchema.taxNumber.validators, formSchema.taxNumber.label)}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.taxNumber.name]} />
                <InputGroup style={{ width: '100%' }}>
                  <Controller
                    name={formSchema.taxNumber.name}
                    control={control}
                    defaultValue={formSchema.taxNumber.value}
                    rules={isValidators(formSchema.taxNumber.validators)}
                    render={(props) => {
                      return (
                        <Input
                          placeholder={formSchema.taxNumber.label}
                          value={props.value}
                          maxLength={getMaxLengthData(formSchema.taxNumber.validators).value}
                          onChange={(value, e) => {
                            if (isNaN(value)) {
                              return
                            }
                            props.onChange(value)
                            setIsVerificationOrg(false)
                          }}
                        />
                      )
                    }}
                  />
                  <Whisper
                    placement="top"
                    open={!isVerificationOrg}
                    speaker={<Tooltip style={{ fontSize: 15 }}>กรุณาตรวจสอบ</Tooltip>}
                  >
                    <InputGroup.Button
                      onClick={() => {
                        if (isVerificationOrg || isLoadingVerification) {
                          return
                        }
                        onClickVerificationOrg()
                      }}
                      disabled={isVerificationOrg || isLoadingVerification}
                    >
                      ตรวจสอบ
                    </InputGroup.Button>
                  </Whisper>
                </InputGroup>
              </Col>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(formSchema.juristicName.validators, formSchema.juristicName.label)}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.juristicName.name]} />
                <Input
                  name={formSchema.juristicName.name}
                  defaultValue={formSchema.juristicName.value}
                  inputRef={register(isValidators(formSchema.juristicName.validators))}
                  placeholder={'ระบุ' + formSchema.juristicName.label}
                />
              </Col>
            </Row>
          </>
        )}
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.startDate.validators, formSchema.startDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.startDate.name]} />
            <Controller
              key={formSchema.startDate.name}
              name={formSchema.startDate.name}
              control={control}
              defaultValue={
                formSchema.startDate.value
                  ? moment(formSchema.startDate.value, DATE_PICKER_FORMAT).toDate()
                  : moment().startOf('day').toDate()
              }
              rules={isValidators(formSchema.startDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    startDate={sessionGetItemStr('projectStartDate')}
                    endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.endDate.validators, formSchema.endDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.endDate.name]} />
            <Controller
              key={formSchema.endDate.name}
              name={formSchema.endDate.name}
              control={control}
              defaultValue={
                formSchema.endDate.value
                  ? moment(formSchema.endDate.value, DATE_PICKER_FORMAT).toDate()
                  : moment().startOf('day').toDate()
              }
              rules={isValidators(formSchema.endDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    startDate={sessionGetItemStr('projectStartDate')}
                    endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.blacklistAbandonmentType.validators,
                formSchema.blacklistAbandonmentType.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.blacklistAbandonmentType.name]} />
            <Controller
              name={formSchema.blacklistAbandonmentType.name}
              control={control}
              defaultValue={formSchema.blacklistAbandonmentType.value}
              rules={isValidators(formSchema.blacklistAbandonmentType.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    style={{ minWidth: '100%' }}
                    virtualized={false}
                    searchable={false}
                    data={formSchema.blacklistAbandonmentType.options}
                    value={props.value}
                    menuAutoWidth
                    placeholder={'เลือก' + formSchema.blacklistAbandonmentType.label}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.blacklistStatus.validators,
                formSchema.blacklistStatus.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.blacklistStatus.name]} />
            <Controller
              name={formSchema.blacklistStatus.name}
              control={control}
              defaultValue={formSchema.blacklistStatus.value}
              rules={isValidators(formSchema.blacklistStatus.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    style={{ minWidth: '100%' }}
                    virtualized={false}
                    searchable={false}
                    data={formSchema.blacklistStatus.options}
                    value={props.value}
                    menuAutoWidth
                    placeholder={'เลือก' + formSchema.blacklistStatus.label}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            <ControlLabel>{formSchema.note.label}</ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <InputForm
              schema={formSchema.note}
              rows={4}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel
            />
          </Col>
        </Row>

        {projectLists.length > 0 && considerResultSchema?.considerResult && (
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
              <ControlLabel>{'โครงการที่เกี่ยวข้อง'}</ControlLabel>
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <Table
                autoHeight={projectLists && projectLists.length < 5}
                height={300}
                rowHeight={60}
                data={projectLists}
                bordered
                loading={isLoadingVerification}
              >
                <Column minWidth={120} flexGrow={1}>
                  <HeaderCell>รหัสโครงการ</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return rowData.projectCode
                    }}
                  </Cell>
                </Column>

                <Column minWidth={120} flexGrow={1}>
                  <HeaderCell>เกี่ยวข้องเป็น</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return rowData.relate
                    }}
                  </Cell>
                </Column>

                <Column minWidth={150} flexGrow={1}>
                  <HeaderCell>ผลการพิจารณา</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      // if (rowData.status != 'EDIT') {
                      //   return getValueFromOptions(mockSchemaTable.considerResult.options, rowData?.considerResult)
                      // }

                      return (
                        <EditSelectCell
                          // id={`${considerResultSchema.considerResult.name}[${index}]`}
                          id={`${considerResultSchema.considerResult.name}[${index}]`}
                          rowData={rowData}
                          rowSchema={considerResultSchema.considerResult}
                          // rowSchema={{
                          //   ...considerResultSchema.considerResult,
                          //   options: listOptions,
                          // }}
                          dataKey={considerResultSchema.considerResult.name}
                          register={register}
                          control={control}
                          errors={errors}
                          isEdit={true}
                          isArray={true}
                          //onChangeCell={(value) => onChangeCellValue(index, value, considerResultSchema.considerResult.name)}
                        />
                      )
                    }}
                  </Cell>
                </Column>
              </Table>
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginLeft: -10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.attachFiles.validators, formSchema.attachFiles.header)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.attachFiles.name]} />
            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={isValidators(formSchema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.attachFiles.disabled}
                    fileListVisible={true}
                    // listType="picture-text"
                    fileList={props.value || []}
                    multiple
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={true}
                onPreview={onPreview}
                onDownload={onDownload}
                onDelete={(rowData) => handleDeleteFileTable(rowData)}
              />
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
